import detail from './detail'
import download from './download'
import like from './like'
import likelist from './likelist'
import lyric from './lyric'
import scrobble from './scrobble'
import url from './url'

export default {
  detail,
  like,
  likelist,
  lyric,
  scrobble,
  url,
  download
}
